import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { IToastContext, ToastContext } from "../../../providers/Toast";
import { AuthState } from "../../../context/auth/auth/reducer";
import { createMattermostUser } from "../../../context/auth/action";
import Button from "../../../components/shared/button/Button";
import CustomInputText from "../../../components/shared/forms/input/CustomInputText";
import _environment from "../../../_environment/_environment";

const ProfileChatView = ({ ...props }: any) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Reference to Redux store dispatch function: use it to dispatch actions.
  const dispatch = useDispatch();

  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  const [pending, setPending] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const enableMattermostAccount = async () => {
    setPending(true);

    try {
      const mattermostData = await createMattermostUser(user);

      openToast({
        type: "success",
        title: "success.general.title",
        message: "success.chat_account_created",
        callback: () => {
        },
      });

      // Dispatch update
      dispatch({
        type: "USER_UPDATE",
        payload: {
          ...user,
          ...{
            mattermost: mattermostData,
          },
        },
      });

      // TODO: send email mattermost init
    } catch (error) {
      console.error(error);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: error.message,
        noTranslateMessage: true,
        callback: () => {
        },
      });
    } finally {
      setPending(false);
    }
  };

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="my-events profile-section">
      <div className="header">
        <h1>{t("pages.profile.chat.title")}</h1>
        <p className="desc mb-4">{t("pages.profile.chat.description")}</p>
        <div className="image">
          <img src="/assets/images/undraw/chat.png"/>
        </div>
      </div>

      {/* Enable account */}
      {!user?.mattermost && (
        <>
          <p className="desc mb-4">{t("pages.profile.chat.description_disabled")}</p>
          <div className="text-right">
            <Button
              onClick={enableMattermostAccount}
              className="btn btn-primary"
              loading={pending}
              disabled={pending}
            >
              Enable account
            </Button>
          </div>
        </>
      )}

      {!!user?.mattermost && (
        <>
          <p className="desc mb-4">{t("pages.profile.chat.description_enabled")}</p>
          <form className="user">
            {/* <div className="form-group">
                        <CustomInputText
                            label={t("forms.username")}
                            name="mattermost_username"
                            id="mattermost_username"
                            value={user?.mattermost?.username}
                        />
                    </div> */}
            <div className="form-group">
              <CustomInputText
                disabled={true}
                label={t("forms.email")}
                name="mattermost_email"
                id="mattermost_email"
                defaultValue={user?.email}
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <p>The same password you are using for this application.</p>
              {/* <CustomInputPassword
                disabled={true}
                copy={true}
                label={t("forms.password")}
                name="mattermost_password"
                id="mattermost_password"
                value={user?.mattermost?.password}
              /> */}
            </div>
          </form>
          <div className="text-right">
            <a
              className="btn btn-primary"
              href={`${_environment.mattermost.URL}/${_environment.mattermost.generalRoom}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Go to chat room <i className="fas fa-comments"></i>
            </a>
          </div>
        </>
      )}
    </div>
  );
};
export default ProfileChatView;
